<template>
  <div
    class="scheduled-gathering-container"
    :class="{ 'is-orange': areItemsVisible }"
    @click="expandSchedule()"
  >
    <div class="title-content">
      <span>
        Número da Solicitação:
        <span>{{ order.solicitationId }}</span>
      </span>
      <span class="date">
        Data prevista de Coleta:
        <span>{{ collectionDate }}</span>
      </span>
      <a class="arrow-icon" :class="[arrowRotate ? 'is-down' : 'is-up']"
        >&#9002;</a
      >
    </div>
    <div class="items-title" v-show="areItemsVisible">
      <h3>Itens:</h3>
    </div>
    <ul v-show="areItemsVisible">
      <li v-for="item in order.items" :key="item.partNumber">
        <h4>&#9656; {{ item.material }} - PartNumber: {{ item.partNumber }}</h4>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ScheduledGathering",
  props: ["order"],
  data: function() {
    return {
      areItemsVisible: false,
      arrowRotate: false,
      collectionDate: ""
    };
  },
  methods: {
    expandSchedule() {
      this.areItemsVisible = !this.areItemsVisible;
      this.arrowRotate = !this.arrowRotate;
    }
  },
  created() {
    this.collectionDate = this.order.scheduleDate;
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_colors.scss";

.scheduled-gathering-container {
  margin: 22px 10px;
  border-bottom: 2px solid $grey8;
  border-left: 3px solid $grey2;
  background-color: $grey4;
  padding: 14px;
  min-width: 800px;
  box-shadow: 1px 2px 5px $grey4;
  user-select: none;
  position: relative;

  .title-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    & > span {
      font-weight: 400;
      white-space: nowrap;
      width: 40%;

      span {
        font-weight: 600;
        color: $orange1;
      }
    }

    .date {
      font-size: 16px;
      position: relative;
    }

    .date::before {
      content: "";
      background: $grey1;
      position: absolute;
      bottom: -8px;
      left: -12px;
      width: 1px;
      height: 35px;
    }
  }

  .arrow-icon {
    // position: absolute;
    // top: 7px;
    // right: 11px;
    font-size: 18px;
    color: $grey1;
    transform: rotate(90deg);
  }

  .is-down {
    top: 0;
    right: 9px;
    transform: rotate(-90deg);
  }

  .is-up {
    transform: rotate(90deg);
  }

  .items-title {
    margin-top: 30px;
    margin-bottom: 12px;
    width: 81.4%;
    border-bottom: 2px solid $grey8;
    box-sizing: border-box;

    h3 {
      margin: 0;
      padding-bottom: 2px;
      font-weight: 400;
    }
  }

  ul {
    padding: 10px;
    margin: 0;
    background-color: $grey7;
    box-sizing: border-box;
    width: 81.4%;

    li {
      color: $orange1;
      list-style: none;

      h4 {
        font-weight: 400;
        color: $grey1;
        margin-top: 5px;
      }
    }
  }

  &:hover {
    background-color: $grey6;
    border-left-color: $orange1;
    cursor: pointer;
  }
}

.is-orange {
  border-left-color: $orange1;
}
</style>
